import { IS_PROD } from '../config/env.config';
import Axios from "axios";

// NOTE: Security headers like CSP, X-Frame-Options, HSTS, X-XSS-Protection,
// X-Content-Type-Options, Cross-Origin-*-Policy, Permissions-Policy, and
// Referrer-Policy are RESPONSE headers. They must be set by your server
// (or CDN/reverse proxy) on the responses it sends the browser — setting
// them on an outgoing axios *request* has no effect, and can trigger
// unnecessary CORS preflights if your API doesn't allow-list them.
// Move that config server-side (e.g. via `helmet` if you're on Express).

const axios = Axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Add "X-Status" header in production only
if (IS_PROD) {
  axios.defaults.headers["X-Status"] = "web";
}

export default axios;